// @flow
import moment from 'moment';

export default class RefreshToken {
  value: string;
  expiration: moment;

  constructor(value: string, expiration: moment) {
    this.value = value;
    this.expiration = expiration;
  }

  isExpired = () => {
    return moment().isAfter(this.expiration);
  }

  withExpiration = (expiration: moment) => {
    return new RefreshToken(this.value, expiration);
  }

  static toJson = (token: RefreshToken): string => {
    const { value, expiration } = token;
    return JSON.stringify({ value, expiration });
  }

  static fromJson = (json: ?string): ?RefreshToken => {
    if (!json) {
      return undefined;
    }

    const converter = (key, value) => {
      if (key === 'expiration') {
        return moment(value);
      }
      return value;
    };

    const { value, expiration } = JSON.parse(json, converter);
    return new RefreshToken(value, expiration);
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/authentication/session/domain/RefreshToken.js